import moment from "moment";
export function parseQuotation(data) {
    var quotation = data;
    quotation.created_at = moment(data.created_at);
    quotation.updated_at = moment(data.updated_at);
    return quotation;
}
export function blankQuotation() {
    return {};
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUXVvdGF0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiUXVvdGF0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sTUFBZ0IsTUFBTSxRQUFRLENBQUM7QUF3RHRDLE1BQU0sVUFBVSxjQUFjLENBQUMsSUFBUztJQUN0QyxJQUFNLFNBQVMsR0FBRyxJQUFpQixDQUFDO0lBQ3BDLFNBQVMsQ0FBQyxVQUFVLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsQ0FBQztJQUMvQyxTQUFTLENBQUMsVUFBVSxHQUFJLE1BQU0sQ0FBQyxJQUFJLENBQUMsVUFBVSxDQUFDLENBQUM7SUFDaEQsT0FBTyxTQUFTLENBQUM7QUFDbkIsQ0FBQztBQUVELE1BQU0sVUFBVSxjQUFjO0lBQzVCLE9BQU8sRUFBZSxDQUFDO0FBQ3pCLENBQUMifQ==